
import CommonData from "@/modules/cabinet/CommonData.vue";
import DetailData from "@/modules/cabinet/DetailData.vue";
import SubscriptionBot from "@/modules/cabinet/SubscriptionBot.vue";
import { Profile } from "@/modules/cabinet/profile.interface";
import Vue from "vue";

export default Vue.extend({
  components: { DetailData, CommonData, SubscriptionBot },

  props: {},

  data() {
    return {
      tab: null,
      items: ["Общие данные", "Детальная информация", "Настройки", "Уведомления"],
      profile: null as Profile | null,
      passform: {
        old: "",
        new: "",
        confirm: "",
      },
    };
  },

  async created() {
    await this.loadProfile();
  },

  methods: {
    async loadProfile() {
      const { data } = await this.$http.get("v1/mis/profile");
      this.profile = data?.data || null;
      console.log({ ...data?.data });
    },
  },
});
